// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epd {
  --epd-ink: #212121;
  --epd-muted: #616161;
  --epd-line: #e0e0e0;
  --epd-dash: #cfd8dc;
  --epd-grid-line: #c5d0d8;
  --epd-surface: #ffffff;
  --epd-canvas: #f4f7f9;
  --epd-primary: #1976d2;
  --epd-primary-dark: #0d47a1;
  --epd-info: #e3f2fd;
  --epd-info-ink: #0d47a1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: calc(100vh - 72px);
  min-width: 0;
  color: var(--epd-ink);
}

.emr-mz-dashboard .emr-mz-main:has(.epd) {
  padding: 10px 12px 12px !important;
  max-width: none;
  display: flex;
  flex-direction: column;
}

.epd__pagehead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.epd__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.epd__title {
  margin: 0;
  font-size: var(--emr-type-page-title);
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--epd-ink);
}

.epd__badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  font-size: var(--emr-type-metadata);
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--epd-primary);
  background: #e3f2fd;
  border: 1px solid #bbdefb;
}

.epd__subtitle {
  margin: 2px 0 0;
  font-size: var(--emr-type-helper);
  color: var(--epd-muted);
}

.epd__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.epd__actions > * {
  flex: 0 0 auto;
}

.epd__grid-size {
  height: 36px;
  width: auto;
  min-width: 118px;
  max-width: 160px;
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  border: 1px solid var(--epd-line);
  background: var(--epd-surface);
  color: var(--epd-ink);
  font-size: var(--emr-type-label);
  font-weight: 500;
}

.epd__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  margin: 0;
  border: 0;
  background: var(--epd-primary) !important;
  color: #fff !important;
  font-size: var(--emr-type-button);
  font-weight: 600;
  line-height: 36px;
  cursor: pointer;
  box-shadow: none !important;
  text-transform: none;
  white-space: nowrap;
}

.epd__btn:hover:not(:disabled),
.epd__btn:focus:not(:disabled) {
  background: var(--epd-primary-dark) !important;
  color: #fff !important;
}

.epd__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.epd__btn--add {
  gap: 6px;
  background: #fff !important;
  color: var(--epd-primary) !important;
  border: 1px solid var(--epd-primary);
}

.epd__btn--add:hover:not(:disabled),
.epd__btn--add:focus:not(:disabled) {
  background: #e3f2fd !important;
  color: var(--epd-primary-dark) !important;
  border-color: var(--epd-primary-dark);
}

.epd__btn-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.epd__btn--ghost {
  background: #fff !important;
  color: var(--epd-ink) !important;
  border: 1px solid var(--epd-line);
}

.epd__btn--ghost:hover:not(:disabled),
.epd__btn--ghost:focus:not(:disabled) {
  background: #f5f5f5 !important;
  color: var(--epd-ink) !important;
}

.epd__workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 12px;
  align-items: start;
  flex: 0 0 auto;
  min-height: 0;
  width: 100%;
}

.epd__stage {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  grid-template-rows: 22px auto;
  gap: 0;
  min-width: 0;
  width: 100%;
  height: auto;
  background: var(--epd-surface);
  border: 1px solid var(--epd-line);
  padding: 8px 12px 12px 8px;
}

.epd__corner {
  grid-column: 1;
  grid-row: 1;
}

.epd__col-axis {
  grid-column: 2;
  grid-row: 1;
  display: grid;
  grid-template-columns: repeat(var(--epd-cols), minmax(0, 1fr));
  align-items: center;
  color: var(--epd-muted);
  font-size: var(--emr-type-micro);
  font-weight: 600;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
}

.epd__row-axis {
  grid-column: 1;
  grid-row: 2;
  display: grid;
  grid-template-rows: repeat(var(--epd-rows), minmax(0, 1fr));
  align-items: center;
  justify-items: center;
  color: var(--epd-muted);
  font-size: var(--emr-type-micro);
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
}

.epd__canvas {
  grid-column: 2;
  grid-row: 2;
  position: relative;
  display: grid;
  width: 100%;
  height: auto;
  aspect-ratio: var(--epd-cols) / var(--epd-rows);
  grid-template-columns: repeat(var(--epd-cols), minmax(0, 1fr));
  grid-template-rows: repeat(var(--epd-rows), minmax(0, 1fr));
  min-height: 0;
  background-color: var(--epd-canvas);
  background-image:
    linear-gradient(to right, var(--epd-grid-line) 1px, transparent 1px),
    linear-gradient(to bottom, var(--epd-grid-line) 1px, transparent 1px);
  background-size: calc(100% / var(--epd-cols)) calc(100% / var(--epd-rows));
  background-position: 0 0;
  border: 1px solid var(--epd-dash);
  touch-action: none;
}

.epd__cell {
  box-sizing: border-box;
  pointer-events: none;
}

.epd__card {
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.epd__card.is-selected {
  z-index: 2;
  box-shadow: 0 0 0 1px currentColor;
}

.epd__card--rtf {
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column;
  overflow: hidden;
  -webkit-user-select: text;
          user-select: text;
  cursor: default;
}

.epd__card--rtf .epd__drag-handle,
.epd__card--rtf .epd__resize-handle,
.epd__card--table .epd__drag-handle,
.epd__card--table .epd__resize-handle,
.epd__card--search .epd__drag-handle,
.epd__card--search .epd__resize-handle {
  z-index: 3;
}

.epd__card--table,
.epd__card--search {
  align-items: stretch;
  justify-content: flex-start;
  flex-direction: column;
  overflow: hidden;
  -webkit-user-select: text;
          user-select: text;
  cursor: default;
}

.epd__rtf {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
}

.epd__rtf-toolbar {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 1px;
  height: 36px;
  padding: 0 8px 0 6px;
  border: 1px solid var(--epd-line);
  background: var(--epd-surface);
  overflow-x: auto;
  max-width: 100%;
}

.epd__rtf-toolbar.is-disabled {
  opacity: 0.42;
}

.epd__rtf-label {
  margin-right: 4px;
  padding-right: 6px;
  border-right: 1px solid var(--epd-line);
  color: var(--epd-muted);
  font-size: var(--emr-type-metadata);
  font-weight: var(--emr-weight-title);
  letter-spacing: 0.04em;
  line-height: 1;
  white-space: nowrap;
}

.epd__rtf-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 3px;
  background: transparent;
  color: #424242;
  box-shadow: none;
  cursor: pointer;
}

.epd__rtf-btn:hover:not(:disabled),
.epd__rtf-btn:focus:not(:disabled) {
  background: rgba(13, 71, 161, 0.08);
  color: var(--epd-primary);
  box-shadow: none;
}

.epd__rtf-btn:disabled {
  cursor: not-allowed;
  color: #9e9e9e;
}

.epd__rtf-icon {
  width: 14px;
  height: 14px;
}

.epd__rtf-sep {
  width: 1px;
  height: 16px;
  margin: 0 4px;
  background: var(--epd-line);
}

.epd__rtf-select {
  height: 28px;
  width: auto;
  max-width: 88px;
  margin: 0 2px;
  padding: 0 4px;
  border: 1px solid var(--epd-line);
  border-radius: 3px;
  background: #fff;
  color: var(--epd-ink);
  font-size: var(--emr-type-label);
}

.epd__rtf-select:disabled {
  color: var(--epd-muted);
  background: #fafafa;
}

.epd__rtf-surface,
.epd__rtf-preview {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  padding: 22px 10px 14px;
  color: #212121;
  font-size: var(--emr-type-body);
  line-height: 1.4;
  outline: none;
  cursor: text;
}

.epd__rtf-surface:empty:before {
  content: attr(data-empty-hint);
  color: #9e9e9e;
  pointer-events: none;
}

.epd__rtf-preview {
  cursor: default;
  padding: 6px 8px;
}

.epd__rtf-surface p,
.epd__rtf-preview p,
.epd__rtf-surface div,
.epd__rtf-preview div {
  margin: 0 0 0.2em;
}

.epd__rtf-surface ul,
.epd__rtf-preview ul,
.epd__rtf-surface ol,
.epd__rtf-preview ol {
  margin: 0 0 0.2em 1.15em;
  padding: 0;
}

.epd__card-title {
  font-size: var(--emr-type-section-title);
  font-weight: var(--emr-weight-title);
  letter-spacing: 0.04em;
  color: #212121;
  pointer-events: none;
}

.epd__drag-handle {
  position: absolute;
  top: 8px;
  left: 8px;
  display: grid;
  grid-template-columns: repeat(3, 4px);
  grid-template-rows: repeat(2, 4px);
  gap: 3px;
  padding: 4px;
  margin: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
  cursor: grab;
  touch-action: none;
}

.epd__drag-handle:active {
  cursor: grabbing;
}

.epd__drag-dot {
  width: 4px;
  height: 4px;
  background: currentColor;
  opacity: 0.85;
}

.epd__resize-handle {
  position: absolute;
  right: 4px;
  bottom: 4px;
  width: 10px;
  height: 10px;
  margin: 0;
  padding: 0;
  background: transparent;
  box-shadow: none;
  border: 0;
  border-right: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  cursor: nwse-resize;
  touch-action: none;
}

.epd__panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  background: var(--epd-surface);
  border: 1px solid var(--epd-line);
  padding: 10px 12px 12px;
}

.epd__tabs {
  display: flex;
  gap: 16px;
  border-bottom: 1px solid var(--epd-line);
  margin-bottom: 12px;
}

.epd__tab {
  height: 32px;
  padding: 0;
  border: 0;
  background: transparent !important;
  color: var(--epd-muted) !important;
  font-size: var(--emr-type-button);
  font-weight: 600;
  cursor: pointer;
  box-shadow: none !important;
  text-transform: none;
}

.epd__tab:hover,
.epd__tab:focus {
  background: transparent !important;
  color: var(--epd-primary) !important;
  box-shadow: none !important;
}

.epd__tab.is-active,
.epd__tab.is-active:hover,
.epd__tab.is-active:focus {
  color: var(--epd-primary) !important;
  background: transparent !important;
  box-shadow: inset 0 -2px 0 var(--epd-primary) !important;
}

.epd__hint {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin-bottom: 10px;
  padding: 6px 8px;
  background: var(--epd-info);
  color: var(--epd-info-ink);
  font-size: var(--emr-type-metadata);
  line-height: 1.4;
}

.epd__hint-icon {
  width: 14px;
  height: 14px;
  margin-top: 1px;
  flex-shrink: 0;
}

.epd__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}

.epd__label {
  font-size: var(--emr-type-label);
  font-weight: 600;
  color: var(--epd-ink);
}

.epd__readonly {
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  border: 1px solid var(--epd-line);
  background: #fafafa;
  color: var(--epd-muted);
  font-size: var(--emr-type-body);
}

.epd__pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.epd__input,
.epd__select,
.epd__color {
  height: 32px;
  width: 100%;
  border: 1px solid var(--epd-line);
  background: #fff;
  color: var(--epd-ink);
  font-size: var(--emr-type-body);
  padding: 0 8px;
  margin: 0;
}

.epd__select {
  display: block;
  border-radius: 0;
}

/* Materialize's scoped \`input[type=…]:not(.browser-default)\` rule pins these
   fields to 16px, out-specifying \`.epd__input\` above. Reclaim the size only;
   the geometry Materialize imposes is left as it renders today. */
.emr-mz-dashboard .epd .epd__field .epd__input,
.emr-mz-dashboard .epd .epd__field .epd__color {
  font-size: var(--emr-type-body);
}

.epd__input:disabled,
.epd__select:disabled,
.epd__color:disabled {
  background: #fafafa;
  color: var(--epd-muted);
}

.epd__color-row {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  gap: 6px;
  align-items: center;
}

.epd__accordion {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.epd__section {
  border: 1px solid var(--epd-line);
  background: #fff;
}

.epd__section-head {
  display: flex !important;
  align-items: center;
  gap: 8px;
  min-height: 30px;
  padding: 0 8px;
  margin: 0;
  cursor: pointer;
  list-style: none;
  -webkit-user-select: none;
          user-select: none;
  background: transparent !important;
  box-shadow: none !important;
  color: var(--epd-ink) !important;
  text-transform: none;
}

.epd__section-head::-webkit-details-marker {
  display: none;
}

.epd__section-num {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--epd-primary);
  color: #fff;
  font-size: var(--emr-type-micro);
  font-weight: 700;
  line-height: 1;
}

.epd__section-icon-wrap {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e3f2fd;
  color: var(--epd-primary);
}

.epd__section-icon {
  width: 13px;
  height: 13px;
  color: var(--epd-primary);
  flex-shrink: 0;
}

.epd__section-title {
  flex: 1 1;
  font-size: var(--emr-type-card-title);
  font-weight: var(--emr-weight-title);
  color: var(--epd-ink);
}

.epd__section-chevron {
  width: 14px;
  height: 14px;
  color: var(--epd-muted);
  flex-shrink: 0;
  transition: transform 0.15s ease;
}

.epd__section[open] .epd__section-chevron {
  transform: rotate(180deg);
}

.epd__section-body {
  padding: 6px 8px 8px;
  border-top: 1px solid var(--epd-line);
}

.epd__section .epd__field {
  margin-bottom: 8px;
}

.epd__section .epd__field:last-child {
  margin-bottom: 0;
}

.epd__soon {
  margin: 0 0 2px;
  padding: 6px 8px;
  background: #fff8e1;
  color: #7a5b00;
  font-size: var(--emr-type-metadata);
  line-height: 1.35;
}

.epd__help {
  margin: 0 0 6px;
  padding: 8px 10px;
  background: var(--epd-info);
  color: var(--epd-info-ink);
  font-size: var(--emr-type-metadata);
  line-height: 1.4;
}

.epd__tip {
  margin: 8px 0 0;
  font-size: var(--emr-type-metadata);
  color: var(--epd-muted);
  line-height: 1.4;
}

.epd__field--split {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.epd__manage {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
}

.epd__manage .epd__btn {
  flex: 1 1;
  min-width: 0;
  width: auto;
  height: 32px;
  padding: 0 8px;
  font-size: var(--emr-type-button-compact);
  line-height: 32px;
}

.epd__btn--danger {
  background: #fff !important;
  color: #c62828 !important;
  border: 1px solid #e57373;
}

.epd__btn--danger:hover:not(:disabled),
.epd__btn--danger:focus:not(:disabled) {
  background: #fdecea !important;
  color: #b71c1c !important;
}

.epd__btn--danger-solid {
  background: #c62828 !important;
  color: #fff !important;
}

.epd__btn--danger-solid:hover:not(:disabled),
.epd__btn--danger-solid:focus:not(:disabled) {
  background: #b71c1c !important;
  color: #fff !important;
}

.epd__modal {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(33, 33, 33, 0.45);
}

.epd__modal-card {
  width: min(360px, calc(100vw - 32px));
  background: #fff;
  border: 1px solid var(--epd-line);
  padding: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
}

.epd__modal-card h3 {
  margin: 0 0 6px;
  font-size: var(--emr-type-section-title);
  font-weight: 600;
}

.epd__modal-card p {
  margin: 0 0 14px;
  font-size: var(--emr-type-body);
  color: var(--epd-muted);
  line-height: 1.45;
}

.epd__modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.epd__note {
  margin-top: 8px;
  padding-top: 10px;
  border-top: 1px solid var(--epd-line);
}

.epd__note h3 {
  margin: 0 0 4px;
  font-size: var(--emr-type-label);
  font-weight: var(--emr-weight-title);
}

.epd__note p {
  margin: 0;
  font-size: var(--emr-type-helper);
  color: var(--epd-muted);
  line-height: 1.45;
}

.epd__stack {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.epd__stack-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--epd-line);
  background: #fff;
  color: var(--epd-ink);
  text-align: left;
  cursor: pointer;
  box-shadow: none;
  text-transform: none;
}

.epd__stack-item:hover,
.epd__stack-item:focus {
  background: #fafafa;
  color: var(--epd-ink);
}

.epd__stack-item.is-selected {
  border-color: var(--epd-primary);
  box-shadow: inset 3px 0 0 var(--epd-primary);
}

.epd__stack-title {
  font-size: var(--emr-type-label);
  font-weight: var(--emr-weight-label);
}

.epd__stack-meta {
  font-size: var(--emr-type-metadata);
  color: var(--epd-muted);
}

.epd--preview .epd__workspace {
  grid-template-columns: minmax(0, 1fr);
}

.epd--preview .epd__stage,
.epd__stage--preview {
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto;
  border: 0;
  padding: 0;
  background: transparent;
  min-height: 0;
  width: 100%;
}

.epd--preview .epd__canvas,
.epd__canvas--preview {
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  height: auto;
  aspect-ratio: var(--epd-cols) / var(--epd-rows);
  border: 0;
  background-color: var(--epd-surface);
  background-image: none;
  touch-action: auto;
}

.epd--preview .epd__card,
.epd__canvas--preview .epd__card {
  cursor: default;
  outline: none;
  box-shadow: none;
}

.epd--preview .epd__card.is-selected,
.epd__canvas--preview .epd__card.is-selected {
  z-index: 1;
  box-shadow: none;
}

.epd__modal-card--wide {
  width: min(720px, calc(100vw - 32px));
}

.epd__content-pick {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 12px 0 16px;
}

.epd__content-pick .epd__btn {
  width: 100%;
}

.epd__steps {
  display: flex;
  gap: 12px;
  margin: 0 0 12px;
  flex-wrap: wrap;
}

.epd__step {
  font-size: var(--emr-type-helper);
  font-weight: 600;
  color: var(--epd-muted);
}

.epd__step.is-active {
  color: var(--epd-primary);
}

.epd__col-board {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}

.epd__col-list {
  min-height: 160px;
  max-height: 240px;
  overflow: auto;
  border: 1px solid var(--epd-line);
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.epd__col-selected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 8px;
  border: 1px solid var(--epd-line);
  background: #fff;
}

.epd__col-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.epd__btn--tiny {
  height: 24px;
  padding: 0 6px;
  font-size: var(--emr-type-metadata);
  line-height: 24px;
}

.epd__table,
.epd__search {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  width: 100%;
  height: 100%;
}

.epd__search-box {
  position: relative;
  flex-shrink: 0;
  padding: 0 8px 6px;
}

.epd__search-box .epd__input {
  width: 100%;
  padding-left: 26px;
}

.epd__search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  color: var(--epd-muted);
  pointer-events: none;
}

.epd__table-title {
  flex-shrink: 0;
  padding: 20px 10px 6px;
  font-size: var(--emr-type-card-title);
  font-weight: var(--emr-weight-title);
  color: var(--epd-ink);
}

.epd__table-wrap {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 0 8px 8px;
}

.epd__table-empty {
  margin: 8px;
  font-size: var(--emr-type-helper);
  color: var(--epd-muted);
}

.epd__data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--emr-type-table-dense);
}

.epd__data-table th,
.epd__data-table td {
  border: 1px solid var(--epd-line);
  padding: 4px 6px;
  text-align: left;
  vertical-align: top;
}

.epd__data-table th {
  background: #f4f7f9;
  font-weight: var(--emr-weight-title);
}

@media (max-width: 1100px) {
  .epd__workspace {
    grid-template-columns: minmax(0, 1fr);
  }

  .epd__stage {
    min-height: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-page-designer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,SAAS;EACT,SAAS;EACT,yCAAyC;EACzC,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,6BAA6B;EAC7B,MAAM;EACN,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,8DAA8D;EAC9D,2DAA2D;EAC3D,aAAa;EACb,mCAAmC;EACnC;;yEAEuE;EACvE,0EAA0E;EAC1E,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,uBAAuB;EACvB,mCAAmC;EACnC,oCAAoC;EACpC,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,sBAAsB;EACtB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;;EAGE,oCAAoC;EACpC,kCAAkC;EAClC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;;EAGE,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;kEAEkE;AAClE;;EAEE,+BAA+B;AACjC;;AAEA;;;EAGE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;EACrC,wBAAwB;EACxB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,SAAS;EACT,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qCAAqC;EACrC,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;EAEE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,WAAW;EACb;AACF","sourcesContent":[".epd {\n  --epd-ink: #212121;\n  --epd-muted: #616161;\n  --epd-line: #e0e0e0;\n  --epd-dash: #cfd8dc;\n  --epd-grid-line: #c5d0d8;\n  --epd-surface: #ffffff;\n  --epd-canvas: #f4f7f9;\n  --epd-primary: #1976d2;\n  --epd-primary-dark: #0d47a1;\n  --epd-info: #e3f2fd;\n  --epd-info-ink: #0d47a1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-height: calc(100vh - 72px);\n  min-width: 0;\n  color: var(--epd-ink);\n}\n\n.emr-mz-dashboard .emr-mz-main:has(.epd) {\n  padding: 10px 12px 12px !important;\n  max-width: none;\n  display: flex;\n  flex-direction: column;\n}\n\n.epd__pagehead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.epd__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.epd__title {\n  margin: 0;\n  font-size: var(--emr-type-page-title);\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--epd-ink);\n}\n\n.epd__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  font-size: var(--emr-type-metadata);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: var(--epd-primary);\n  background: #e3f2fd;\n  border: 1px solid #bbdefb;\n}\n\n.epd__subtitle {\n  margin: 2px 0 0;\n  font-size: var(--emr-type-helper);\n  color: var(--epd-muted);\n}\n\n.epd__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.epd__actions > * {\n  flex: 0 0 auto;\n}\n\n.epd__grid-size {\n  height: 36px;\n  width: auto;\n  min-width: 118px;\n  max-width: 160px;\n  display: inline-flex;\n  align-items: center;\n  padding: 0 10px;\n  border: 1px solid var(--epd-line);\n  background: var(--epd-surface);\n  color: var(--epd-ink);\n  font-size: var(--emr-type-label);\n  font-weight: 500;\n}\n\n.epd__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 14px;\n  margin: 0;\n  border: 0;\n  background: var(--epd-primary) !important;\n  color: #fff !important;\n  font-size: var(--emr-type-button);\n  font-weight: 600;\n  line-height: 36px;\n  cursor: pointer;\n  box-shadow: none !important;\n  text-transform: none;\n  white-space: nowrap;\n}\n\n.epd__btn:hover:not(:disabled),\n.epd__btn:focus:not(:disabled) {\n  background: var(--epd-primary-dark) !important;\n  color: #fff !important;\n}\n\n.epd__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.epd__btn--add {\n  gap: 6px;\n  background: #fff !important;\n  color: var(--epd-primary) !important;\n  border: 1px solid var(--epd-primary);\n}\n\n.epd__btn--add:hover:not(:disabled),\n.epd__btn--add:focus:not(:disabled) {\n  background: #e3f2fd !important;\n  color: var(--epd-primary-dark) !important;\n  border-color: var(--epd-primary-dark);\n}\n\n.epd__btn-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.epd__btn--ghost {\n  background: #fff !important;\n  color: var(--epd-ink) !important;\n  border: 1px solid var(--epd-line);\n}\n\n.epd__btn--ghost:hover:not(:disabled),\n.epd__btn--ghost:focus:not(:disabled) {\n  background: #f5f5f5 !important;\n  color: var(--epd-ink) !important;\n}\n\n.epd__workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 320px;\n  gap: 12px;\n  align-items: start;\n  flex: 0 0 auto;\n  min-height: 0;\n  width: 100%;\n}\n\n.epd__stage {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr);\n  grid-template-rows: 22px auto;\n  gap: 0;\n  min-width: 0;\n  width: 100%;\n  height: auto;\n  background: var(--epd-surface);\n  border: 1px solid var(--epd-line);\n  padding: 8px 12px 12px 8px;\n}\n\n.epd__corner {\n  grid-column: 1;\n  grid-row: 1;\n}\n\n.epd__col-axis {\n  grid-column: 2;\n  grid-row: 1;\n  display: grid;\n  grid-template-columns: repeat(var(--epd-cols), minmax(0, 1fr));\n  align-items: center;\n  color: var(--epd-muted);\n  font-size: var(--emr-type-micro);\n  font-weight: 600;\n  text-align: center;\n  user-select: none;\n}\n\n.epd__row-axis {\n  grid-column: 1;\n  grid-row: 2;\n  display: grid;\n  grid-template-rows: repeat(var(--epd-rows), minmax(0, 1fr));\n  align-items: center;\n  justify-items: center;\n  color: var(--epd-muted);\n  font-size: var(--emr-type-micro);\n  font-weight: 600;\n  user-select: none;\n}\n\n.epd__canvas {\n  grid-column: 2;\n  grid-row: 2;\n  position: relative;\n  display: grid;\n  width: 100%;\n  height: auto;\n  aspect-ratio: var(--epd-cols) / var(--epd-rows);\n  grid-template-columns: repeat(var(--epd-cols), minmax(0, 1fr));\n  grid-template-rows: repeat(var(--epd-rows), minmax(0, 1fr));\n  min-height: 0;\n  background-color: var(--epd-canvas);\n  background-image:\n    linear-gradient(to right, var(--epd-grid-line) 1px, transparent 1px),\n    linear-gradient(to bottom, var(--epd-grid-line) 1px, transparent 1px);\n  background-size: calc(100% / var(--epd-cols)) calc(100% / var(--epd-rows));\n  background-position: 0 0;\n  border: 1px solid var(--epd-dash);\n  touch-action: none;\n}\n\n.epd__cell {\n  box-sizing: border-box;\n  pointer-events: none;\n}\n\n.epd__card {\n  position: absolute;\n  z-index: 1;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid;\n  user-select: none;\n  cursor: pointer;\n}\n\n.epd__card.is-selected {\n  z-index: 2;\n  box-shadow: 0 0 0 1px currentColor;\n}\n\n.epd__card--rtf {\n  align-items: stretch;\n  justify-content: flex-start;\n  flex-direction: column;\n  overflow: hidden;\n  user-select: text;\n  cursor: default;\n}\n\n.epd__card--rtf .epd__drag-handle,\n.epd__card--rtf .epd__resize-handle,\n.epd__card--table .epd__drag-handle,\n.epd__card--table .epd__resize-handle,\n.epd__card--search .epd__drag-handle,\n.epd__card--search .epd__resize-handle {\n  z-index: 3;\n}\n\n.epd__card--table,\n.epd__card--search {\n  align-items: stretch;\n  justify-content: flex-start;\n  flex-direction: column;\n  overflow: hidden;\n  user-select: text;\n  cursor: default;\n}\n\n.epd__rtf {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.epd__rtf-toolbar {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 1px;\n  height: 36px;\n  padding: 0 8px 0 6px;\n  border: 1px solid var(--epd-line);\n  background: var(--epd-surface);\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n.epd__rtf-toolbar.is-disabled {\n  opacity: 0.42;\n}\n\n.epd__rtf-label {\n  margin-right: 4px;\n  padding-right: 6px;\n  border-right: 1px solid var(--epd-line);\n  color: var(--epd-muted);\n  font-size: var(--emr-type-metadata);\n  font-weight: var(--emr-weight-title);\n  letter-spacing: 0.04em;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.epd__rtf-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 3px;\n  background: transparent;\n  color: #424242;\n  box-shadow: none;\n  cursor: pointer;\n}\n\n.epd__rtf-btn:hover:not(:disabled),\n.epd__rtf-btn:focus:not(:disabled) {\n  background: rgba(13, 71, 161, 0.08);\n  color: var(--epd-primary);\n  box-shadow: none;\n}\n\n.epd__rtf-btn:disabled {\n  cursor: not-allowed;\n  color: #9e9e9e;\n}\n\n.epd__rtf-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.epd__rtf-sep {\n  width: 1px;\n  height: 16px;\n  margin: 0 4px;\n  background: var(--epd-line);\n}\n\n.epd__rtf-select {\n  height: 28px;\n  width: auto;\n  max-width: 88px;\n  margin: 0 2px;\n  padding: 0 4px;\n  border: 1px solid var(--epd-line);\n  border-radius: 3px;\n  background: #fff;\n  color: var(--epd-ink);\n  font-size: var(--emr-type-label);\n}\n\n.epd__rtf-select:disabled {\n  color: var(--epd-muted);\n  background: #fafafa;\n}\n\n.epd__rtf-surface,\n.epd__rtf-preview {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow: auto;\n  padding: 22px 10px 14px;\n  color: #212121;\n  font-size: var(--emr-type-body);\n  line-height: 1.4;\n  outline: none;\n  cursor: text;\n}\n\n.epd__rtf-surface:empty:before {\n  content: attr(data-empty-hint);\n  color: #9e9e9e;\n  pointer-events: none;\n}\n\n.epd__rtf-preview {\n  cursor: default;\n  padding: 6px 8px;\n}\n\n.epd__rtf-surface p,\n.epd__rtf-preview p,\n.epd__rtf-surface div,\n.epd__rtf-preview div {\n  margin: 0 0 0.2em;\n}\n\n.epd__rtf-surface ul,\n.epd__rtf-preview ul,\n.epd__rtf-surface ol,\n.epd__rtf-preview ol {\n  margin: 0 0 0.2em 1.15em;\n  padding: 0;\n}\n\n.epd__card-title {\n  font-size: var(--emr-type-section-title);\n  font-weight: var(--emr-weight-title);\n  letter-spacing: 0.04em;\n  color: #212121;\n  pointer-events: none;\n}\n\n.epd__drag-handle {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  display: grid;\n  grid-template-columns: repeat(3, 4px);\n  grid-template-rows: repeat(2, 4px);\n  gap: 3px;\n  padding: 4px;\n  margin: 0;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n  cursor: grab;\n  touch-action: none;\n}\n\n.epd__drag-handle:active {\n  cursor: grabbing;\n}\n\n.epd__drag-dot {\n  width: 4px;\n  height: 4px;\n  background: currentColor;\n  opacity: 0.85;\n}\n\n.epd__resize-handle {\n  position: absolute;\n  right: 4px;\n  bottom: 4px;\n  width: 10px;\n  height: 10px;\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  box-shadow: none;\n  border: 0;\n  border-right: 2px solid currentColor;\n  border-bottom: 2px solid currentColor;\n  cursor: nwse-resize;\n  touch-action: none;\n}\n\n.epd__panel {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  overflow: auto;\n  background: var(--epd-surface);\n  border: 1px solid var(--epd-line);\n  padding: 10px 12px 12px;\n}\n\n.epd__tabs {\n  display: flex;\n  gap: 16px;\n  border-bottom: 1px solid var(--epd-line);\n  margin-bottom: 12px;\n}\n\n.epd__tab {\n  height: 32px;\n  padding: 0;\n  border: 0;\n  background: transparent !important;\n  color: var(--epd-muted) !important;\n  font-size: var(--emr-type-button);\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: none !important;\n  text-transform: none;\n}\n\n.epd__tab:hover,\n.epd__tab:focus {\n  background: transparent !important;\n  color: var(--epd-primary) !important;\n  box-shadow: none !important;\n}\n\n.epd__tab.is-active,\n.epd__tab.is-active:hover,\n.epd__tab.is-active:focus {\n  color: var(--epd-primary) !important;\n  background: transparent !important;\n  box-shadow: inset 0 -2px 0 var(--epd-primary) !important;\n}\n\n.epd__hint {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  margin-bottom: 10px;\n  padding: 6px 8px;\n  background: var(--epd-info);\n  color: var(--epd-info-ink);\n  font-size: var(--emr-type-metadata);\n  line-height: 1.4;\n}\n\n.epd__hint-icon {\n  width: 14px;\n  height: 14px;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\n.epd__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.epd__label {\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  color: var(--epd-ink);\n}\n\n.epd__readonly {\n  height: 32px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  border: 1px solid var(--epd-line);\n  background: #fafafa;\n  color: var(--epd-muted);\n  font-size: var(--emr-type-body);\n}\n\n.epd__pair {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.epd__input,\n.epd__select,\n.epd__color {\n  height: 32px;\n  width: 100%;\n  border: 1px solid var(--epd-line);\n  background: #fff;\n  color: var(--epd-ink);\n  font-size: var(--emr-type-body);\n  padding: 0 8px;\n  margin: 0;\n}\n\n.epd__select {\n  display: block;\n  border-radius: 0;\n}\n\n/* Materialize's scoped `input[type=…]:not(.browser-default)` rule pins these\n   fields to 16px, out-specifying `.epd__input` above. Reclaim the size only;\n   the geometry Materialize imposes is left as it renders today. */\n.emr-mz-dashboard .epd .epd__field .epd__input,\n.emr-mz-dashboard .epd .epd__field .epd__color {\n  font-size: var(--emr-type-body);\n}\n\n.epd__input:disabled,\n.epd__select:disabled,\n.epd__color:disabled {\n  background: #fafafa;\n  color: var(--epd-muted);\n}\n\n.epd__color-row {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr);\n  gap: 6px;\n  align-items: center;\n}\n\n.epd__accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.epd__section {\n  border: 1px solid var(--epd-line);\n  background: #fff;\n}\n\n.epd__section-head {\n  display: flex !important;\n  align-items: center;\n  gap: 8px;\n  min-height: 30px;\n  padding: 0 8px;\n  margin: 0;\n  cursor: pointer;\n  list-style: none;\n  user-select: none;\n  background: transparent !important;\n  box-shadow: none !important;\n  color: var(--epd-ink) !important;\n  text-transform: none;\n}\n\n.epd__section-head::-webkit-details-marker {\n  display: none;\n}\n\n.epd__section-num {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--epd-primary);\n  color: #fff;\n  font-size: var(--emr-type-micro);\n  font-weight: 700;\n  line-height: 1;\n}\n\n.epd__section-icon-wrap {\n  flex-shrink: 0;\n  width: 22px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #e3f2fd;\n  color: var(--epd-primary);\n}\n\n.epd__section-icon {\n  width: 13px;\n  height: 13px;\n  color: var(--epd-primary);\n  flex-shrink: 0;\n}\n\n.epd__section-title {\n  flex: 1;\n  font-size: var(--emr-type-card-title);\n  font-weight: var(--emr-weight-title);\n  color: var(--epd-ink);\n}\n\n.epd__section-chevron {\n  width: 14px;\n  height: 14px;\n  color: var(--epd-muted);\n  flex-shrink: 0;\n  transition: transform 0.15s ease;\n}\n\n.epd__section[open] .epd__section-chevron {\n  transform: rotate(180deg);\n}\n\n.epd__section-body {\n  padding: 6px 8px 8px;\n  border-top: 1px solid var(--epd-line);\n}\n\n.epd__section .epd__field {\n  margin-bottom: 8px;\n}\n\n.epd__section .epd__field:last-child {\n  margin-bottom: 0;\n}\n\n.epd__soon {\n  margin: 0 0 2px;\n  padding: 6px 8px;\n  background: #fff8e1;\n  color: #7a5b00;\n  font-size: var(--emr-type-metadata);\n  line-height: 1.35;\n}\n\n.epd__help {\n  margin: 0 0 6px;\n  padding: 8px 10px;\n  background: var(--epd-info);\n  color: var(--epd-info-ink);\n  font-size: var(--emr-type-metadata);\n  line-height: 1.4;\n}\n\n.epd__tip {\n  margin: 8px 0 0;\n  font-size: var(--emr-type-metadata);\n  color: var(--epd-muted);\n  line-height: 1.4;\n}\n\n.epd__field--split {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n}\n\n.epd__manage {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.epd__manage .epd__btn {\n  flex: 1 1 0;\n  min-width: 0;\n  width: auto;\n  height: 32px;\n  padding: 0 8px;\n  font-size: var(--emr-type-button-compact);\n  line-height: 32px;\n}\n\n.epd__btn--danger {\n  background: #fff !important;\n  color: #c62828 !important;\n  border: 1px solid #e57373;\n}\n\n.epd__btn--danger:hover:not(:disabled),\n.epd__btn--danger:focus:not(:disabled) {\n  background: #fdecea !important;\n  color: #b71c1c !important;\n}\n\n.epd__btn--danger-solid {\n  background: #c62828 !important;\n  color: #fff !important;\n}\n\n.epd__btn--danger-solid:hover:not(:disabled),\n.epd__btn--danger-solid:focus:not(:disabled) {\n  background: #b71c1c !important;\n  color: #fff !important;\n}\n\n.epd__modal {\n  position: fixed;\n  inset: 0;\n  z-index: 40;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(33, 33, 33, 0.45);\n}\n\n.epd__modal-card {\n  width: min(360px, calc(100vw - 32px));\n  background: #fff;\n  border: 1px solid var(--epd-line);\n  padding: 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);\n}\n\n.epd__modal-card h3 {\n  margin: 0 0 6px;\n  font-size: var(--emr-type-section-title);\n  font-weight: 600;\n}\n\n.epd__modal-card p {\n  margin: 0 0 14px;\n  font-size: var(--emr-type-body);\n  color: var(--epd-muted);\n  line-height: 1.45;\n}\n\n.epd__modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.epd__note {\n  margin-top: 8px;\n  padding-top: 10px;\n  border-top: 1px solid var(--epd-line);\n}\n\n.epd__note h3 {\n  margin: 0 0 4px;\n  font-size: var(--emr-type-label);\n  font-weight: var(--emr-weight-title);\n}\n\n.epd__note p {\n  margin: 0;\n  font-size: var(--emr-type-helper);\n  color: var(--epd-muted);\n  line-height: 1.45;\n}\n\n.epd__stack {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.epd__stack-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid var(--epd-line);\n  background: #fff;\n  color: var(--epd-ink);\n  text-align: left;\n  cursor: pointer;\n  box-shadow: none;\n  text-transform: none;\n}\n\n.epd__stack-item:hover,\n.epd__stack-item:focus {\n  background: #fafafa;\n  color: var(--epd-ink);\n}\n\n.epd__stack-item.is-selected {\n  border-color: var(--epd-primary);\n  box-shadow: inset 3px 0 0 var(--epd-primary);\n}\n\n.epd__stack-title {\n  font-size: var(--emr-type-label);\n  font-weight: var(--emr-weight-label);\n}\n\n.epd__stack-meta {\n  font-size: var(--emr-type-metadata);\n  color: var(--epd-muted);\n}\n\n.epd--preview .epd__workspace {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.epd--preview .epd__stage,\n.epd__stage--preview {\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-rows: auto;\n  border: 0;\n  padding: 0;\n  background: transparent;\n  min-height: 0;\n  width: 100%;\n}\n\n.epd--preview .epd__canvas,\n.epd__canvas--preview {\n  grid-column: 1;\n  grid-row: 1;\n  width: 100%;\n  height: auto;\n  aspect-ratio: var(--epd-cols) / var(--epd-rows);\n  border: 0;\n  background-color: var(--epd-surface);\n  background-image: none;\n  touch-action: auto;\n}\n\n.epd--preview .epd__card,\n.epd__canvas--preview .epd__card {\n  cursor: default;\n  outline: none;\n  box-shadow: none;\n}\n\n.epd--preview .epd__card.is-selected,\n.epd__canvas--preview .epd__card.is-selected {\n  z-index: 1;\n  box-shadow: none;\n}\n\n.epd__modal-card--wide {\n  width: min(720px, calc(100vw - 32px));\n}\n\n.epd__content-pick {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  margin: 12px 0 16px;\n}\n\n.epd__content-pick .epd__btn {\n  width: 100%;\n}\n\n.epd__steps {\n  display: flex;\n  gap: 12px;\n  margin: 0 0 12px;\n  flex-wrap: wrap;\n}\n\n.epd__step {\n  font-size: var(--emr-type-helper);\n  font-weight: 600;\n  color: var(--epd-muted);\n}\n\n.epd__step.is-active {\n  color: var(--epd-primary);\n}\n\n.epd__col-board {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.epd__col-list {\n  min-height: 160px;\n  max-height: 240px;\n  overflow: auto;\n  border: 1px solid var(--epd-line);\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.epd__col-selected {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 8px;\n  border: 1px solid var(--epd-line);\n  background: #fff;\n}\n\n.epd__col-actions {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.epd__btn--tiny {\n  height: 24px;\n  padding: 0 6px;\n  font-size: var(--emr-type-metadata);\n  line-height: 24px;\n}\n\n.epd__table,\n.epd__search {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.epd__search-box {\n  position: relative;\n  flex-shrink: 0;\n  padding: 0 8px 6px;\n}\n\n.epd__search-box .epd__input {\n  width: 100%;\n  padding-left: 26px;\n}\n\n.epd__search-icon {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 14px;\n  height: 14px;\n  color: var(--epd-muted);\n  pointer-events: none;\n}\n\n.epd__table-title {\n  flex-shrink: 0;\n  padding: 20px 10px 6px;\n  font-size: var(--emr-type-card-title);\n  font-weight: var(--emr-weight-title);\n  color: var(--epd-ink);\n}\n\n.epd__table-wrap {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 0 8px 8px;\n}\n\n.epd__table-empty {\n  margin: 8px;\n  font-size: var(--emr-type-helper);\n  color: var(--epd-muted);\n}\n\n.epd__data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--emr-type-table-dense);\n}\n\n.epd__data-table th,\n.epd__data-table td {\n  border: 1px solid var(--epd-line);\n  padding: 4px 6px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.epd__data-table th {\n  background: #f4f7f9;\n  font-weight: var(--emr-weight-title);\n}\n\n@media (max-width: 1100px) {\n  .epd__workspace {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .epd__stage {\n    min-height: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
